import { render } from "./Deposits.vue?vue&type=template&id=fb373ada&ts=true"
import script from "./Deposits.vue?vue&type=script&lang=ts"
export * from "./Deposits.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__